// Phase 59: account helpers.
// account = (現金 / 銀行 / 信用卡 等) — a wallet/bank the user owns.
// Each transaction belongs to exactly one account.

export const DEFAULT_ACCOUNT_ID = 'default-cash-account';
export const ACCOUNT_TYPES = [
  { value: 'cash',    label: { 'zh-Hant': '現金',     'zh-Hans': '现金',     'en': 'Cash',      'ja': '現金' }, icon: '💵', color: '#10b981' },
  { value: 'bank',    label: { 'zh-Hant': '銀行戶口', 'zh-Hans': '银行户口', 'en': 'Bank',      'ja': '銀行口座' }, icon: '🏦', color: '#3b82f6' },
  { value: 'ewallet', label: { 'zh-Hant': '電子錢包', 'zh-Hans': '电子钱包', 'en': 'e-Wallet',  'ja': '電子ウォレット' }, icon: '📱', color: '#8b5cf6' },
  { value: 'credit',  label: { 'zh-Hant': '信用卡',   'zh-Hans': '信用卡',   'en': 'Credit',    'ja': 'クレジットカード' }, icon: '💳', color: '#ec4899' },
  { value: 'other',   label: { 'zh-Hant': '其他',     'zh-Hans': '其他',     'en': 'Other',     'ja': 'その他' }, icon: '📂', color: '#64748b' },
];

export function accountTypeMeta(type) {
  return ACCOUNT_TYPES.find(t => t.value === type) || ACCOUNT_TYPES[ACCOUNT_TYPES.length - 1];
}

export function accountLabel(account, lang = 'zh-Hant') {
  if (!account) return '';
  if (typeof account.name === 'string') return account.name;
  return account.name?.[lang] || account.name?.['zh-Hant'] || account.name?.en || Object.values(account.name || {})[0] || '?';
}

/**
 * Compute per-account running balance given the full tx list + account list.
 * Sums up expense (subtracts) + income (adds) per account, ordered by date asc.
 * Returns Map<accountId, balance>
 */
export function computeAccountBalances(transactions, accounts) {
  const balances = new Map();
  for (const a of accounts) balances.set(a.local_uuid, 0);
  // Sort by occurred_on asc
  const sorted = [...transactions].sort((a, b) => (a.occurred_on || '').localeCompare(b.occurred_on || ''));
  for (const tx of sorted) {
    if (tx.deleted) continue;
    const aid = tx.account_local_uuid || DEFAULT_ACCOUNT_ID;
    const sign = tx.type === 'income' ? 1 : -1;
    balances.set(aid, (balances.get(aid) || 0) + sign * (tx.amount || 0));
  }
  return balances;
}
